import { gql } from "@apollo/client";

export const GET_COUNCIL_CATEGORIES = gql`
  query GetCouncilCategories {
    council_categories {
      id
      image_url_svg
      image_url_png
      name
    }
  }
`;

export const GET_USER_WITH_COUNCIL_PROFILE = gql`
  query GetUserWithCouncilProfile {
    users {
      id
      full_name
      email
      mobile_number
      council_profile {
        id
        name
        population
        state
        description
        council_cover_path
        council_cover_photo
        council_profile_path
        council_profile_photo
        email
        mobile_number
        website
        categories
      }
    }
  }
`;
